<template>
  <v-card
    elevation="20"
    max-width="344"
    class="mb-5"
    @click.stop="showActions = !showActions"
  >
    <v-list-item three-line>
      <v-list-item-content>
        <div class="overline">
          <v-icon
            v-if="review.tripexpert_id"
            color="yellow"
          >
            mdi-license
          </v-icon>
          {{ review.provider.name }}
        </div>
        <v-card-text class="caption pa-0">{{ review.text }}</v-card-text>
      </v-list-item-content>
      <v-list-item-avatar
        tile
        size="65"
      >
        <v-img
          v-if="review.provider.public_link"
          :src="review.provider.public_link"
        />
      </v-list-item-avatar>
    </v-list-item>

    <v-expand-transition>
      <v-row v-if="showActions" justify="end" class="mx-5">
        <v-icon
            large
            @click.stop="edit"
            color="orange"
        >
          mdi-pen
        </v-icon>
        <v-spacer/>
        <v-icon
          v-if="!hasSomeAbilities($constants.ABILITY.INTERN)"
          large
          @click.stop="remove"
          color="red"
        >
          mdi-delete
        </v-icon>
      </v-row>
    </v-expand-transition>

  </v-card>
</template>

<script>
export default {
  name: 'ReviewCard',
  props: ['review'],
  data: () => ({
    showActions: false,
  }),

  methods: {
    remove() {
      this.$confirm('Are you sure you want to delete this review?').then((res) => {
        if (!res) return;
        this.$emit('remove');
      });
    },

    edit() {
      this.$emit('edit');
    },
  },
};
</script>
